import { OCONNELL_CENTER_DATA } from "@/data/oconnellCenterData";

export const OConnellMapLegend = () => {
  const featureTypes = [
    { icon: "🤫", label: "Quiet Zone / Sensory Room", color: "#34D399" },
    { icon: "♿", label: "Wheelchair Accessible", color: "#60A5FA" },
    { icon: "🎧", label: "Sensory-Friendly Seating", color: "#A78BFA" },
    { icon: "🏥", label: "Medical / First Aid", color: "#F87171" },
    { icon: "ℹ️", label: "Guest Services", color: "#FBBF24" },
    { icon: "🚪", label: "Emergency Exit", color: "#6B7280" },
    { icon: "🚻", label: "Accessible Restroom", color: "#06B6D4" },
  ];

  const energyLevels = [
    { color: "#34D399", label: "Low Energy (Quiet)" },
    { color: "#FBBF24", label: "Medium Energy" },
    { color: "#F87171", label: "High Energy (Loud)" },
  ];

  const unseenDisabilities = OCONNELL_CENTER_DATA.unseenDisabilitiesSupport;

  return (
    <div className="space-y-4">
      {/* Feature Types */}
      <div
        className="info-card"
        role="region"
        aria-label="O'Connell Center map legend"
        data-testid="oconnell-map-legend"
      >
        <h3
          className="text-sm font-semibold mb-3"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          Accessibility Features
        </h3>
        <div className="grid grid-cols-2 gap-2">
          {featureTypes.map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-xs">
              <span className="text-base">{item.icon}</span>
              <span className="text-muted-foreground">{item.label}</span>
            </div>
          ))}
        </div>

        {/* Energy Levels */}
        <h3
          className="text-sm font-semibold mb-2 mt-4 pt-3 border-t"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          Sensory Levels
        </h3>
        <div className="flex flex-wrap gap-3">
          {energyLevels.map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-xs">
              <span
                className="w-3 h-3 rounded-full border border-white shadow-sm"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-muted-foreground">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Unseen Disabilities Support */}
      <div className="info-card">
        <h3
          className="text-sm font-semibold mb-3"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          Unseen Disabilities Support
        </h3>
        <div className="grid grid-cols-2 gap-2">
          {unseenDisabilities.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-2 p-2 bg-secondary rounded-lg"
            >
              <span className="text-lg">{item.icon}</span>
              <span className="text-xs font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Communication Support */}
      <div className="info-card">
        <h3
          className="text-sm font-semibold mb-3"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          Communication Support
        </h3>
        <div className="space-y-2">
          {OCONNELL_CENTER_DATA.communicationSupport.map((item) => (
            <div key={item.name} className="text-xs">
              <span className="font-medium">{item.name}</span>
              {item.contact && (
                <span className="text-muted-foreground block">
                  Contact: {item.contact}
                </span>
              )}
              {item.locations && (
                <span className="text-muted-foreground block">
                  Available at: {item.locations}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
